import {
  Box,
  Typography,
  Button,
  Card,
  CardMedia,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Banner from "@/layouts/Banner/Banner";
import useInitializeAuth from "@/hooks/useInitializeAuth";
import card from "../../../../assets/card.png";

export default function HomeComponent() {
  useInitializeAuth();
  const navigate = useNavigate();

  const handleNavigate = () => {
    // Optional: track click event here
    // analytics.track("Clicked Find Mortgage Brokers");
    // navigate("/customer/search-brokers");
  };

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        p: { xs: 1, md: 2 },
        bgcolor: "background.paper",
        borderRadius: {
          xs: "8px 0 0 8px",
          md: "12px 0 0 12px"
        },
        boxShadow: 3,
        border: "2px solid",
        borderColor: "divider",
        marginLeft: { xs: 0, md: 2 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: { xs: 1, md: 1 },
        }}
      >
        <Banner />

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            flexWrap: "wrap",
            alignItems: { xs: "stretch", md: "center" },
            justifyContent: "space-between",
            gap: { xs: 2, md: 6 },
          }}
        >
          {/* Left section */}
          <Box
            sx={{
              flex: 1,
              minWidth: 300,
              p: { xs: 2, md: 4 },
            }}
          >
          <Typography
            variant="h3"
            sx={{
              fontWeight: "bold",
              fontSize: {
                xs: "1rem",
                sm: "1.5rem",
                md: "2rem",
                lg: "1.5rem",
                xl: "2.5rem",
                xxl: "3rem",
              },
              lineHeight: {
                xs: "1rem",
                sm: "1.25rem",
                md: "1.75rem",
                lg: "1.5rem",
                xl: "2.5rem",
                xxl: "3rem", // Custom
              },
              mb: 1,
            }}
          >

              Looking for the best deal on your mortgage? Start by finding the
              right broker
            </Typography>

            <Typography
              sx={{
                color: "text.secondary",
                fontSize: {
                  xs: "0.65rem",
                  sm: "0.85rem",
                  md: "1rem",
                  lg: "0.8rem",
                  xl: "1.15rem",
                  xxl: "1.25rem", // Custom
                },
                lineHeight: {
                  xs: "1.5rem",
                  sm: "1.65rem",
                  md: "1.75rem",
                  lg: "1.20rem",
                  xl: "2rem",
                  xxl: "2.5rem", // Custom
                },
                mb: 2,
              }}
>
              Buying your <b>first home</b> or <b>refinancing</b>? We make it easy to connect
              with trusted, experienced mortgage brokers who can help you secure
              the <b>best deal</b>. Whether you're looking for <b>low-interest rates</b>,
              expert guidance, or tailored loan solutions, the right broker can
              save you <b>time</b>, <b>stress</b>, and <b>money</b>. Start your journey with
              confidence—find your perfect match today.
            </Typography>

            <Button
              variant="contained"
              onClick={handleNavigate}
              sx={{
                borderRadius: "24px",
                px: 3,
                py: 1.25,
                bgcolor: "#5A48F6",
                "&:hover": { bgcolor: "#4e3fd1" },
              }}
            >
              Find Mortgage Brokers →
            </Button>
          </Box>

          {/* Right section */}
          <Box
            sx={{
              flex: 1,
              minWidth: 300,
              textAlign: { xs: "left", md: "right" },
              p: { xs: 2, md: 0 },
            }}
          >
            <Card
              elevation={0}
              sx={{
                p: { xs: 2, md: 3 },
                bgcolor: "transparent",
                boxShadow: "none",
                maxWidth: "100%",
              }}
            >
              <CardMedia
                component="img"
                image={card}
                alt="Mortgage broker team illustration"
                loading="lazy"
              />
            </Card>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
